import { Button } from 'antd';
import React from 'react';

import Help from '@icons/emp/help.svg';
import { useLivelensFindByIpEnabled } from './hooks';

export const Empty = () => {
  const findByIpEnabled = useLivelensFindByIpEnabled();
  return (
    <div style={{ textAlign: 'center', marginTop: 'px' }}>
      <div style={{ marginTop: '60px', marginBottom: '20px' }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="76"
          height="65"
          viewBox="0 0 76 65"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.3895 0.5L14.5319 8.49998H9.38963V13.3073C10.9741 14.0366 12.0573 15.5097 12.0573 17.2082C12.0573 18.9067 10.9741 20.3798 9.38963 21.1091L9.38963 30.8625C10.9741 31.5918 12.0573 33.0649 12.0573 34.7634C12.0573 36.4618 10.9741 37.9349 9.38963 38.6642L9.38963 48.4116C10.9741 49.1409 12.0573 50.614 12.0573 52.3124C12.0573 54.0109 10.9741 55.484 9.38963 56.2133L9.38963 64.499H5.38963L5.38963 56.4178C3.52957 55.7908 2.20703 54.1892 2.20703 52.3124C2.20703 50.4357 3.52957 48.8341 5.38963 48.2071L5.38963 38.8687C3.52957 38.2417 2.20703 36.6401 2.20703 34.7634C2.20703 32.8866 3.52957 31.285 5.38963 30.658L5.38963 21.3136C3.52957 20.6866 2.20704 19.085 2.20704 17.2082C2.20704 15.3314 3.52957 13.7299 5.38963 13.1029V8.49998H0.24707L7.3895 0.5ZM17.7451 14.7715H63.7131V26.4726H23.4911V20.622L17.7451 14.7715ZM75.7524 32.3247H17.7451L23.5458 38.1752V44.0258H75.7524V32.3247ZM63.7131 49.8757H17.7451L23.4911 55.7263V61.5768H63.7131V49.8757Z"
            fill="#E9E9E5"
          />
        </svg>
      </div>
      <div
        style={{
          fontSize: '20px',
          fontWeight: 500,
          marginBottom: '20px',
          color: 'rgba(0, 0, 0, 0.25)',
        }}
      >
        Welcome to Conviva LiveLens! Understand your events while using your product.
      </div>
      <div
        style={{
          fontSize: '16px',
          fontWeight: 500,
          marginBottom: '20px',
          color: 'rgba(0, 0, 0, 0.25)',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        Specify a Client ID or User ID to begin generating the real-time event timeline.
      </div>
      <Button
        style={{ fontSize: '16px', display: 'none' }}
        icon={<Help />}
        type="text"
        onClick={() => {}}
      >
        &nbsp;Viste Help Center
      </Button>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div style={{ fontSize: '14px', textAlign: 'left', color: 'rgba(0, 0, 0, 0.25)' }}>
          <div style={{ fontWeight: 500, marginBottom: '8px' }}>
            Don’t know your Client ID or User ID?
          </div>
          {findByIpEnabled ? (
            <>
              <div>1.Search for “IP“ in your web or mobile browser</div>
              <div>2.Copy and paste your IP in “Find Myself by IP Address“ in LiveLens</div>
              <div>3.Interact with your application on your device</div>
              <div>4.Click your Client ID to view the real-time event timeline</div>
            </>
          ) : (
            <>
              <div>1.Enter a known User ID or Client ID in the search above</div>
              <div>2.Interact with your application on your device</div>
              <div>3.Click your Client ID to view the real-time event timeline</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
